import axios from "axios";

import { ApiService } from "../../servicios/api.service";
import LocalStorageKeys from "../../data/localStorageKeys";

export class ComercioApi {
  static endPoint = "admin/comercio/";

  static get BasePath() {
    return ApiService.api + this.endPoint;
  }

  static get AuthHeader() {
    return "Token " + localStorage.getItem(LocalStorageKeys.token);
  }

  static get Headers() {
    return { Authorization: this.AuthHeader };
  }

  static get Config() {
    return { headers: this.Headers };
  }

  static countWithFilter(filter) {
    return axios.post(this.BasePath + "filter/count", filter, this.Config);
  }

  static create(dto) {
    return axios.post(this.BasePath, dto, this.Config);
  }

  static delete(id) {
    return axios.delete(this.BasePath + id, this.Config);
  }

  static getById(id) {
    return axios.get(this.BasePath + id, this.Config);
  }

  static getActiveList() {
    return axios.get(this.BasePath + "active", this.Config);
  }

  static getListWithFilter(filter) {
    return axios.post(this.BasePath + "filter", filter, this.Config);
  }

  static getMinimumDiscountPercentageByComercioId(comercioId) {
    return axios.get(
      this.BasePath + comercioId + "/minimumDiscountPercentage",
      this.Config
    );
  }

  static hasBeneficioWithLowerDiscount(comercioId, discountPercentage) {
    return axios.get(
      this.BasePath +
        comercioId +
        "/hasBeneficioWithLowerDiscount/" +
        discountPercentage,
      this.Config
    );
  }

  static update(dto) {
    return axios.patch(this.BasePath, dto, this.Config);
  }

  static uploadLogo(comercioId, formData) {
    return axios.post(
      ApiService.api + "uploads/logos/comercios/" + comercioId,
      formData,
      {
        headers: {
          Authorization: this.AuthHeader,
          "Content-Type": "multipart/form-data"
        }
      }
    );
  }
}
